import React from "react";
import classNames from "classnames";
import { View } from "@tarojs/components";

import { XHComponentCommonProps } from "../../types";

import "./index.scss";

export type BadgeProps = {
  content?: string;
} & XHComponentCommonProps;

const Badge: React.FC<BadgeProps> = props => {
  const { content, children } = props;
  const cls = classNames("xh-badge", classNames);

  return <View className={cls}>{!!children ? children : content}</View>;
};

export default Badge;
